import { upperFirst } from 'lodash'
import React from 'react'

import { CurrencyKind } from 'src/api/types/units'
import { convertChartJsDataToComparisonFormat, DatasetCategory } from 'src/commons/chartjs'
import ComparisonPlot from 'src/commons/graphs/ComparisonPlot'
import TemporalStackedHistogram from 'src/commons/graphs/TemporalStackedHistogram'
import { getTranslation } from 'src/commons/i18n'
import { enumsTranslationKeys } from 'src/commons/i18nEnums'
import { IGraphData, IGraphStack } from 'src/commons/types'
import { useCurrencyFormatter } from 'src/layout/AgencySettings'

function translatePolicyKind() {
  const { t } = getTranslation()
  return (policyKind: string) => upperFirst(t(enumsTranslationKeys.PolicyKind[policyKind] || policyKind))
}

export function OffensesPerProviderPerDate(props: IGraphData) {
  return (
    <ComparisonPlot
      title={props.title}
      rawData={convertChartJsDataToComparisonFormat(props.graphReport)}
      granularity={props.granularity}
      enableAnimation={props.enableAnimation}
    />
  )
}

export function OffensePenaltyPerProviderPerDate(props: IGraphData) {
  const formatWithUnit = useCurrencyFormatter(CurrencyKind.Penalty)
  return (
    <ComparisonPlot
      title={props.title}
      rawData={convertChartJsDataToComparisonFormat(props.graphReport)}
      formatWithUnit={formatWithUnit}
      datasetCategory={DatasetCategory.provider}
      granularity={props.granularity}
      enableAnimation={props.enableAnimation}
    />
  )
}

export function OffensesPerKindPerDate(props: IGraphStack) {
  return (
    <TemporalStackedHistogram
      title={props.title}
      rawData={props.graphReport}
      granularity={props.granularity}
      formatLabel={translatePolicyKind()}
      enableAnimation={props.enableAnimation}
    />
  )
}

export function OffensesPerKindPerDatePercentage(props: IGraphStack) {
  return (
    <TemporalStackedHistogram
      title={props.title}
      rawData={props.graphReport}
      formatWithUnit={(amount: string) => `${amount} %`}
      granularity={props.granularity}
      maxValue={100}
      formatLabel={translatePolicyKind()}
      enableAnimation={props.enableAnimation}
    />
  )
}
